import { jsx as s } from "react/jsx-runtime";
import e from "react";
const o = e.createContext(
  void 0
), n = ({
  hasAsChildParent: t,
  children: r
}) => /* @__PURE__ */ s(o.Provider, { value: { hasAsChildParent: t }, children: r });
n.displayName = "AsChildContextProvider";
const d = () => {
  const t = e.useContext(o);
  return t || {
    hasAsChildParent: !1
  };
};
export {
  n as A,
  d as u
};
//# sourceMappingURL=as-child-context.ihEwNgkv.js.map
